import { appendPreferences } from "utils/preferenceBuilder";

const createFormData = (invoice_notification_list, preferences) => {
  
  const isArray = Array.isArray(invoice_notification_list);
  const emailsArray = isArray ? invoice_notification_list : invoice_notification_list.replace(/\s+/g, '').split(',');
  
  const formData = new FormData();

  appendPreferences(formData, preferences);

  formData.append('invoice_notification_list', JSON.stringify(emailsArray));
  
  return formData;
};

export default createFormData;
